import { SalesIndex } from "../views";

export const salesRouter = [
  {
    path: "sales",
    name: "SalesIndex",
    component: SalesIndex
  }
];
